import GsisCallback from "pages/Authentication/Register/GsisCallback";
import RegisterStep1 from "pages/Authentication/Register/RegisterStep1";
import RegisterStep2 from "pages/Authentication/Register/RegisterStep2";
import RegisterStep3 from "pages/Authentication/Register/RegisterStep3";
import { Navigate } from "react-router-dom";
import MinimalLayout from "src/layout/MinimalLayout";
import Error from "../pages/Error";
import LandingPage from "pages/LandingPage";
import PublicLogin from "pages/pubnr/Login";
import GovLogin from "pages/govnr/Login";
import Welcome from "pages/govnr/EmployeeRegister/Welcome";
import EmployeeRegisterForm from "pages/govnr/EmployeeRegister/EmployeeRegisterForm";
import EmployeeRegisterFormPA from "pages/govnr/EmployeeRegister/EmployeeRegisterFormPA";
import GsisInvitationCallback from "pages/Authentication/Register/GsisInvitationCallback";
import GsisPAInvitationCallback from "pages/Authentication/Register/GsisPAInvitationCallback";
import GsisForgotPasswordCallback from "pages/Authentication/ForgotPassword/GsisForgotPasswordCallback";
import ResetPassword from "pages/Authentication/ForgotPassword/ResetPassword";
import GsisPACallback from "pages/govnr/Login/GsisPACallback";

const AuthenticationRoutes = () => {
  return [
    {
      path: "/",
      element: <MinimalLayout />,
      children: [
        { path: "/Auth/GsisCallback", element: <GsisCallback /> },
        { path: "/api/auth/GsisCallback", element: <GsisCallback /> },
        { path: "/api/auth/GsisInvitationCallback", element: <GsisInvitationCallback /> },
        { path: "/api/auth/Gsis_PAInvitationCallback", element: <GsisPAInvitationCallback /> },
        { path: "/api/auth/GsisForgotPasswordCallback", element: <GsisForgotPasswordCallback /> },
        { path: "/api/auth/Gsis_PACallback", element: <GsisPACallback /> },
        { path: "/register", element: <RegisterStep1 /> },
        { path: "/amka-login", element: <RegisterStep2 /> },
        { path: "/employee-amka-login", element: <EmployeeRegisterForm /> },
        { path: "/pa-employee-amka-login", element: <EmployeeRegisterFormPA /> },
        { path: "/registration-form", element: <RegisterStep3 /> },
        { path: "/reset-password/:token", element: <ResetPassword /> },
        { path: "/error", element: <Error /> },
        {
          path: "/pubnr/program-5/login",
          element: <PublicLogin programNumber={5} />,
        },
        {
          path: "/pubnr/program-6/login",
          element: <PublicLogin programNumber={6} />,
        },
        { path: "/govnr/login", element: <GovLogin /> },
        { path: "/govnr/welcome/:token", element: <Welcome /> },
        {
          path: "",
          element: <LandingPage />,
        },
        {
          path: "*",
          element: <Navigate to="" />,
        },
      ],
    },
  ];
};

export default AuthenticationRoutes;
